class MiroTokenManager {
  private static instance: MiroTokenManager
  private tokenUpdatePromise: Promise<string> | null = null
  private cachedToken: string | null = null
  private cachedTokenExpiresAt: number | null = null
  private static readonly REFRESH_BUFFER_MS = 30_000

  private constructor() {}

  public static getInstance = (): MiroTokenManager => {
    if (!MiroTokenManager.instance) {
      MiroTokenManager.instance = new MiroTokenManager()
    }

    return MiroTokenManager.instance
  }

  public getToken = async (): Promise<string> => {
    if (this.hasValidCachedToken()) {
      return this.cachedToken as string
    }

    if (this.tokenUpdatePromise) {
      return this.tokenUpdatePromise
    }

    this.tokenUpdatePromise = this.fetchAndCacheToken()

    try {
      return await this.tokenUpdatePromise
    } finally {
      this.tokenUpdatePromise = null
    }
  }

  private hasValidCachedToken = (): boolean => {
    if (!this.cachedToken || !this.cachedTokenExpiresAt) {
      return false
    }

    return (
      Date.now() + MiroTokenManager.REFRESH_BUFFER_MS <
      this.cachedTokenExpiresAt
    )
  }

  private fetchAndCacheToken = async (): Promise<string> => {
    const token = await this.fetchToken()
    const expiresAt = this.getTokenExpiryMs(token)

    this.cachedToken = token
    this.cachedTokenExpiresAt = expiresAt

    return token
  }

  private getTokenExpiryMs = (token: string): number | null => {
    try {
      const payload = token.split('.')[1]

      if (!payload) {
        return null
      }

      const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/')
      const paddedPayload = normalizedPayload.padEnd(
        Math.ceil(normalizedPayload.length / 4) * 4,
        '=',
      )
      const decodedPayload = JSON.parse(atob(paddedPayload)) as {
        exp?: number
      }

      if (typeof decodedPayload.exp !== 'number') {
        return null
      }

      return decodedPayload.exp * 1000
    } catch {
      return null
    }
  }

  private fetchToken = async (): Promise<string> => {
    const token = await miro.board.getIdToken()

    if (!token) {
      throw new Error('No token found. Redirecting to sign-in.')
    }

    return token
  }
}

export default MiroTokenManager
